import React from "react";
import { getModeIcon } from "../../utils";
import { navigateTo } from "../../utils/navigation";
import { CalendarClock } from "lucide-react";
// import { UserIcon } from '@heroicons/react/24/outline';

const RiskBadge = ({ level }) => {
  const colors = {
    LOW: "bg-[#FFEE33] text-[#334155]",
    MODERATE: "bg-orange-300 text-[#334155]",
    HIGH: "bg-red-500 text-white",
    NA: "bg-[#B7E049] text-[#FFFFFF]",
  };

  return (
    <span
      className={`px-2.5 py-0.5 text-center rounded-full text-[11px] font-semibold font-poppins ${colors[level]}`}
    >
      {level}
    </span>
  );
};

const doNavigation = (item) => {
  console.log("item: " + JSON.stringify(item[0]));
  const item0 = item[0];
  const title = item0.title ? encodeURIComponent(item0.title) : "-";
  const firstName = item0.firstName ? encodeURIComponent(item0.firstName) : "-";
  const lastName = item0.lastName ? encodeURIComponent(item0.lastName || "") : "-";
  const date = encodeURIComponent(item0.date || "");
  const startTime = encodeURIComponent(item0.startTime || "");

  if (item[0].mode === "CHAT") {
  } else if (item[0].mode === "VIDEO" || item[0].mode === "AUDIO") {
    navigateTo(
      "/call/" +
      item[0].channel +
      "/" +
      item[0].mode +
      "/" +
      item[0].appointmentId +
      "/" +
      item[0].uid);
  } else {
    navigateTo(`/inPerson/${item0.channel}/${item0.mode}/${item0.appointmentId}/${item0.uid}/${title}/${firstName}/${lastName}/${date}/${startTime}`);
  }
};

function Index({ avatar, name, mode, time, risk, showJoinNow, item }) {
  return (
    <div className="bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[12px] flex flex-col h-full">
      <div className="flex items-center gap-2 mb-2">
        <div className="flex items-center justify-center w-[28px] h-[28px] rounded-lg bg-[#EFF6FF] text-[#2563EB] flex-shrink-0">
          <CalendarClock size={15} />
        </div>
        <h2 className="text-sm text-[#171717] font-semibold font-poppins mb-0 whitespace-nowrap">
          Upcoming Schedule
        </h2>
        <span className="ml-auto flex flex-row items-center gap-1 text-[#2563EB] text-[10px] font-semibold px-2 py-0.5 rounded-full bg-[#EFF6FF] font-poppins">
          <img
            src={getModeIcon(mode)}
            alt={mode}
            className="w-[12px] h-[12px] object-contain"
          />{" "}
          {mode}
        </span>
      </div>
      <div className="bg-[#F8FAFC] border-[1px] border-solid border-[#F1F5F9] px-[10px] py-[8px] rounded-xl flex-1 flex flex-col justify-center">
        <div className="flex items-center gap-2">
          <img
            src={avatar}
            alt="avatar"
            className="w-[32px] h-[32px] rounded-lg object-cover bg-[#6EE7B7]"
          />
          <div className="flex flex-col min-w-0">
            <h3 className="text-sm font-semibold text-[#171717] font-poppins mb-0 truncate">{name}</h3>
            <span className="text-xs font-medium text-[#64748B] font-poppins">{time}</span>
            <div className="flex items-center gap-1.5 mt-1">
              <span className="text-[#64748B] text-[10px] font-medium uppercase tracking-wide font-poppins">
                Risk
              </span>
              <RiskBadge level={risk} />
            </div>
          </div>
          {showJoinNow ? (
            <button
              className="btn-gradient text-white ml-auto flex-shrink-0 px-[12px] py-[5px] rounded-lg text-xs
        font-semibold transition  font-poppins"
              onClick={() => doNavigation(item)}
            >
              Start Now
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Index;
